import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useTranslator } from '@/hooks/useTranslator';

interface TermsDeclineConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function TermsDeclineConfirmDialog({
  open,
  onCancel,
  onConfirm,
}: TermsDeclineConfirmDialogProps) {
  const { getTranslation: t } = useTranslator({ page: 'termsOfUse' });

  return (
    <AlertDialog open={open} onOpenChange={next => !next && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('declineConfirmTitle')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('declineConfirmDescription')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('declineConfirmCancel')}</AlertDialogCancel>
          <AlertDialogAction variant='destructive' onClick={onConfirm}>
            {t('declineConfirmAction')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
